// @ts-nocheck
import React from "react";
import { Container } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Logo from "../../assets/logo/white.svg";
import "./FooterStyles.css";
// @ts-ignore
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// @ts-ignore
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { Link } from "react-router-dom";
import { COMPANY } from "../../config.js";

export default function Footer(params) {
  return (
    <Container fluid>
      <Col className="footer">
        <Row>
          <Col>
            <h3 className="footer-header">
              Solving the climate emergency starts today
            </h3>
          </Col>
          <Col>
            <Row className="ButtonRow justify-content-end align-items-end mt-2">
              <Col sm="auto">
                <Button as={Link} to="/book" className="footerBtn">Book a Discovery Call</Button>
              </Col>
              <Col sm="auto">
                <Button
                  as={Link}
                  to="/projects"
                  className="footerBtnWhite"
                  variant="outline-light"
                >
                  Explore Projects
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <hr className="footer-hr mb-4" />
        <Row className="footer-sitemap">
          <Col>
            <img
              src={Logo}
              width="64px"
              alt="alphabet greens logo"
            ></img>
          </Col>
          <Col>
            <h5>Projects</h5>
            <ul>
              <li><Link to="/projects/cookstove-project">CookStove</Link></li>
              <li><Link to="/projects/led-project">LED</Link></li>
              <li><Link to="/projects/food-digester-project">Food Digester</Link></li>
              <li><Link to="/projects/solar-project">Solar</Link></li>
            </ul>
          </Col>
          <Col>
            <h5>Services</h5>
            <ul>
              <li><Link to="/services/carbon-offset">Carbon Offset</Link></li>
              <li><Link to="/services/carbon-footprinting">Carbon Footprinting</Link></li>
            </ul>
          </Col>
          <Col>
            <h5>Credits</h5>
            <ul>
              <li><Link to="/services/selling-credits">Selling Credits</Link></li>
              <li><Link to="/services/buying-credits">Buying Credits</Link></li>
              <li><Link to="/impact">Our Impact</Link></li>
              <li><Link to="/map">Project Map</Link></li>
              <li><Link to="/buyers/guide">Buyer Guide</Link></li>
              <li><Link to="/insights">Insights</Link></li>
              <li><Link to="/buyers">For Buyers</Link></li>
              <li><Link to="/sellers">For Sellers</Link></li>
              <li><Link to="/investors">For Investors</Link></li>
            </ul>
          </Col>
          <Col>
            <h5>About</h5>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/manifesto">Manifesto</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </Col>
          <Col>
            <h5>Socials</h5>
            <Row className="footer-socials ">
              <Col>
                <Link to="#">
                  <FontAwesomeIcon
                    className="BannerBtnIcon"
                    icon={icon({ name: "facebook", style: "brands" })}
                  />
                </Link>
              </Col>
              <Col>
                <Link to="#">
                  <FontAwesomeIcon
                    className="BannerBtnIcon"
                    icon={icon({ name: "instagram", style: "brands" })}
                  />
                </Link>
              </Col>
              <Col>
                <Link to="#">
                  <FontAwesomeIcon
                    className="BannerBtnIcon"
                    icon={icon({ name: "twitter", style: "brands" })}
                  />
                </Link>
              </Col>
              <Col>
                <Link to="#">
                  <FontAwesomeIcon
                    className="BannerBtnIcon"
                    icon={icon({ name: "linkedin", style: "brands" })}
                  />
                </Link>
              </Col>
            </Row>
          </Col>
        </Row>
        <hr className="footer-hr mb-4" />
        <Row className="footer-bottom justify-content-between">
          <Col lg={4}>
            © 2026 Alphabet Greens Private Limited
            <div style={{ fontSize: 13, opacity: 0.8, marginTop: 6 }}>{COMPANY.address}</div>
          </Col>
          <Col lg={5}>
            <Row className="justify-content-end">
              <Col lg={3}>
                <Link to="/privacy">Privacy policy</Link>
              </Col>
              <Col lg={3}>
                <Link to="/terms">Terms of service</Link>
              </Col>
              <Col lg={3}>
                <Link to="/legal">Legal Notice</Link>
              </Col>
              <Col lg={3}>
                <Link to="/cookies">Cookies policy</Link>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Container>
  );
}
